module.exports = __webpack_public_path__ + "img/add.50f264e6.svg";